<router-outlet></router-outlet>
<!-- <div sf-footer></div> -->

<ngx-loader [loading]="(loading$ | async)!"> <img src="../assets/images/loader.svg" /></ngx-loader>
